import {
  Alert,
  AlertIcon,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Spinner,
  Text,
} from '@chakra-ui/react';
import {
  offerApi,
  AcceptedInquiryAlignment,
} from '@texas/api/endpoints/offerApi';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { ErrorDetails } from '@texas/components/shared/alert/ErrorDetails';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { OfferDetail } from './OfferDetail';

interface Props {
  offerId: number | null;
  isOpen: boolean;
  onClose: () => void;
  isDefaultCurrency?: boolean;
  matchedInquiry?: AcceptedInquiryAlignment | null;
  customerId?: number;
}

export function MasterOfferDetailDrawer({
  offerId,
  isOpen,
  onClose,
  isDefaultCurrency,
  matchedInquiry,
  customerId,
}: Props) {
  const { t } = useTranslation();
  const { data, loading, error, refetch } = useApiResource(offerApi.getOffer);

  useEffect(() => {
    if (offerId !== null) refetch(offerId);
  }, [offerId, refetch]);

  return (
    <Drawer isOpen={isOpen} onClose={onClose} placement="right" size="md">
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>{t('offer.editMasterOffer')}</DrawerHeader>
        <DrawerBody>
          <Alert status="info" mb={4} borderRadius="md">
            <AlertIcon />
            <Text fontSize="sm">{t('offer.masterOfferNote')}</Text>
          </Alert>
          {loading && <Spinner size="sm" />}
          {error && <ErrorDetails error={error} />}
          {data && offerId !== null && (
            <OfferDetail
              offerId={offerId}
              onChanged={onClose}
              mode="master"
              isDefaultCurrency={isDefaultCurrency}
              matchedInquiry={matchedInquiry}
              customerId={customerId}
            />
          )}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}
